export const contextUiUpdatedMock = {
  dateFormat: 'DD/MM/YYYY',
  language: 'en-US',
};
